export default __webpack_public_path__ + "static/media/instagramIcon.2e9bb30d.svg";